import Layout from "@/views/layout/index";

const moreUnit = [
  {
    path: '',
    name: 'more',
    // target: true,
    hidden: false,
    component: Layout,
    isChildren: true,
    showChildren: true,
    flatNav: false,
    meta: { title: '更多', icon: 'industryCenter/homeMenu_bg' },
    children: [
      {
        path: '/newsCenter',
        meta: { title: '资讯中心', icon: 'el-icon-s-help' },
        mCode: "ZXZX",
        isChildren: true,
        component: () => import('@/views/newsCenter/index'),
      },

      {
        path: '/supplychain',
        meta: { title: '应用中心', icon: 'industryCenter/homeMenu_bg', des: '以列表方式展示电子钱包、应用支付等产品，列表可以多种方式进行筛选，点击具体资源，可打开应用详情页面，查看当前详细' },
        mCode: "YYZX",
        isChildren: true,
        component: () => import('@/views/supplychain/index'),
      },
      {
        path: '/helpCenter',
        meta: { title: '帮助中心', icon: 'el-icon-s-help' },
        mCode: "BZZX",
        isChildren: true,
        component: () => import('@/views/helpCenter/index'),
      },
      {
        path: '/about',
        meta: { title: '关于我们', icon: 'el-icon-s-help' },
        mCode: "GYWM",
        isChildren: true,
        component: () => import('@/views/aboutUs/index'),
      },
    ]
  }
]

export default moreUnit



// WEBPACK FOOTER //
// ./src/router/moreUnit/index.js